
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/cart",
      function () {
        return require("private-next-pages/checkout/cart.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout/cart"])
      });
    }
  